// Named exports of field getters for SSR-safe usage

interface FieldValue {
  internal?: Record<string, any>;
  external?: Record<string, any>;
}

export function setProperFieldInternalFirst(value: FieldValue | null | undefined, field: string): string {
  if (!value) return '';
  return value.internal && value.internal[field]
    ? value.internal[field]
    : value.external && value.external[field]
      ? value.external[field]
      : '';
}

export function setProperFieldExternalFirst(value: FieldValue | null | undefined, field: string): string {
  if (!value) return '';
  return value.external && value.external[field]
    ? value.external[field]
    : value.internal && value.internal[field]
      ? value.internal[field]
      : '';
}

export function setProperFieldExternal(value: FieldValue | null | undefined, field: string): string {
  if (!value) return '';
  return value.external && value.external[field] ? value.external[field] : '';
}

export function setProperFieldInternal(value: FieldValue | null | undefined, field: string): string {
  if (!value) return '';
  return value.internal && value.internal[field] ? value.internal[field] : '';
}
